module.exports = "/assets/da8e2532519396362308c53efec8a475.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2F.png
// module id = 981
// module chunks = 0